module.exports = __webpack_public_path__ + "img/berry.28856f24.svg";